// ── IMAGE SLOTS (Dental Office Ready) ────────────────────────────────
// Hosted in the Impultienda store resources.
const RES = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/9372a121-9d53-42b9-87d2-9aeda7703ab8/';
const COVER = (id: string) =>
  `https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/9372a121-9d53-42b9-87d2-9aeda7703ab8/${id}-mockup.webp?width=720&quality=85&resize=contain`;

/** iMac + 3 tablets + 2 phones mockup, one bonus per device (transparent background) */
const IMAC = RES + '1792536761578_claro-mockup-imac-3tablets-2celus-sin-fondo-90c5eff7.webp';
export const heroMockupUrl = IMAC;
export const offerMockupUrl = IMAC;
/** 6 real pages, in the same order as lookInside.captions */
export const pageImages: string[] = [
  RES + '1792531765996_claro-p01-portada-a1eee83e.webp',
  RES + '1792531770055_claro-p03-sistema-4c884ec7.webp',
  RES + '1792531773818_claro-p08-consent-a69e9cf3.webp',
  RES + '1792531778218_claro-p09-chairside-0e258a02.webp',
  RES + '1792531782082_claro-p10-paciente-d9039b9c.webp',
  RES + '1792531785837_claro-p40-field-card-56bb79d5.webp',
];
/** 5 bonus covers, in the same order as bonuses (and as the checkout) */
export const bonusCovers: string[] = [
  COVER('e730773d-a59d-41c8-ada4-b005cbdbfcc0'),
  COVER('adfb0848-e471-4c00-aff1-1c2452ef5471'),
  COVER('fa055a1e-8fe2-4314-a579-358d816d4a20'),
  COVER('07101d78-1c67-4952-b232-af8f2fdd2cf1'),
  COVER('860a01b5-e2c9-4647-877b-60f8f2aad8fd'),
];
